import { Send } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';

/**
 * Modal that lets a buyer send an inquiry message to the listing's supplier.
 * Extracted from ListingDetailPage.
 */
export default function ContactSellerModal({
  open,
  onOpenChange,
  listing,
  message,
  setMessage,
  sending,
  onSend,
  formatPrice,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-md">
        <DialogHeader>
          <DialogTitle className="font-playfair text-xl">Contact Seller</DialogTitle>
          <DialogDescription>
            Send a message to {listing.supplier_name} about this listing.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="p-4 rounded-lg bg-secondary/30 border border-border/20">
            <p className="font-medium text-sm mb-1">{listing.title}</p>
            <p className="text-accent font-semibold">{formatPrice(listing.price)}</p>
          </div>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Hi, I'm interested in this listing..."
            className="w-full h-32 p-4 bg-secondary/30 border border-border/40 rounded-lg text-foreground placeholder:text-muted-foreground/50 resize-none"
            data-testid="inquiry-message"
          />
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              onClick={onSend}
              disabled={!message.trim() || sending}
              className="flex-1 btn-gold"
              data-testid="send-inquiry-btn"
            >
              {sending ? 'Sending...' : 'Send Message'}
              <Send className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
